export { default } from "./src/statsig-feature-gate-container";
